import React, { useMemo, useState } from "react";
import {
  Button,
  CloseIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  Field,
  Flex,
} from "@aidnas/design-system";
import { Dropdown } from "@aidnas/design-system-bandaid";

import { useChatContext } from "../context/ChatContext";
import type { UserRole } from "../hooks/useChat";

const ROLE_DISPLAY_NAMES: Record<UserRole, string> = {
  general: "General focus",
  designer: "Focus on design",
  developer: "Focus on code",
};

const userRoles = Object.keys(ROLE_DISPLAY_NAMES) as UserRole[];

export function ChatHeader() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { clearMessages, setUserRole, toggleChat, userRole } = useChatContext();

  const roleItems = useMemo(
    () =>
      userRoles.map((role) => ({
        key: role,
        label: ROLE_DISPLAY_NAMES[role],
        onClick: () => setUserRole(role),
      })),
    [setUserRole]
  );

  return (
    <Flex
      align="center"
      gap="spacing-150"
      horizontal
      justify="space-between"
      style={{ width: "100%" }}
    >
      <Field>
        <Dropdown menu={{ items: roleItems }} onOpenChange={setDropdownOpen} trigger={["click"]}>
          <Button iconEnd={dropdownOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />} variant="ghost">
            {ROLE_DISPLAY_NAMES[userRole]}
          </Button>
        </Dropdown>
      </Field>
      <Flex align="center" gap="spacing-150" horizontal>
        <Button
          aria-label="Clear chat"
          density="comfortable"
          onClick={clearMessages}
          variant="subtle"
        >
          New chat
        </Button>
        <Button
          aria-label="Close chat"
          density="comfortable"
          iconEnd={<CloseIcon />}
          onClick={toggleChat}
          variant="outline"
        />
      </Flex>
    </Flex>
  );
}
